import React from 'react';
import PropTypes from 'prop-types';

const Introduction = ({ stops, selectedIndex, selectedValue, selectionHandler, valueHandler, error, disabled = false, refersTo = null, className = '', onFocus, onBlur }) => {

	return (
		<span>
			{/* Space intentionally left blank... for now */}
		</span>
	);
};

Introduction.propTypes = {
	
}

export default Introduction;


// WEBPACK FOOTER //
// ./src/components/step/Introduction.js